import React, {useState} from "react";
import { Button, Column, Columns, Control, Input, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import {useDispatch} from "react-redux";
import {ToastContainer, toast} from "react-toastify";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";


export default function AddPartModal({workLookup, setWorkLookup, open, setOpen, dataFresh}){
    const [partName, setPartName] = useState("");
    const [partNumber, setPartNumber] = useState("");
    const [partCost, setPartCost] = useState();
    const [partCustomerCost, setPartCustomerCost] = useState();
    const [partSupplier, setPartSupplier] = useState();
    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();
    const dispatch = useDispatch();


    const handleSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    }

    const handleSupplierSelect = (e) =>{
        setPartSupplier(e[0]);
    }

    const partValidator = (part) =>{
        return !!(part.name && part.part_number && part.cost && part.supplier && part.customer_cost);
    }

    const addPart = () =>{
        let newWork = {...workLookup}

        let newPart = {
            name: partName,
            part_number: partNumber,
            cost: partCost,
            supplier: partSupplier,
            customer_cost: partCustomerCost
        };
        if(workLookup && workLookup.id){
            newPart.work_lookup =  [workLookup.id]
        }
        if(partValidator(newPart)){
            let oldParts = workLookup.part_work_lookup ? workLookup.part_work_lookup : [];
            oldParts.push(newPart);
            newWork['part_work_lookup'] = oldParts;
            setWorkLookup(newWork);
        }
        else{
            toast.error("All fields are required", {position: "top-right"});
        }
        setSearchData([]);

    }
    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
          closeOnBlur
          active={open}
          onClick={e => {e.stopPropagation()}}
          onClose={() => {
            setOpen(false);
          }}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{backgroundColor: "white"}}>
                    <Title>Add Part</Title>
                    <Columns isMultiline>
                        <Column>
                            <Control>
                                <label className="label">Part Number</label>
                                <Input
                                    type={"text"}
                                    name={""}
                                    onChange={(e) => {
                                        setPartNumber(e.target.value);
                                    }}
                                />
                            </Control>
                        </Column>
                        <Column>
                            <Control>
                                <label className="label">Part Name</label>
                                <Input
                                    type={"text"}
                                    name={""}
                                    onChange={(e) => setPartName(e.target.value)}
                                />
                            </Control>
                        </Column>
                        <Column>
                            <Control>
                                <label className="label">Supplier</label>
                                <AsyncTypeahead
                                  useCache={false}
                                  id="typeahead"
                                  labelKey="display_name"
                                  minLength={2}
                                  name={"supplier"}
                                  onSearch={handleSearch}
                                  onChange={handleSupplierSelect}
                                  placeholder={"Search Supplier"}
                                  disabled={false}
                                  options={searchData}
                                  ref={typeahead => setTypeahead(typeahead)}
                                  className="typeahead"
                                  isLoading={isLoading}
                                  selected={partSupplier ? [partSupplier] : []}
                                />
                            </Control>
                        </Column>
                        <Column>
                            <label className="label">Cost</label>
                            <Control className={"has-icons-left"}>
                                <Input
                                    type={"number"}
                                    name={""}
                                    onChange={(e) => setPartCost(e.target.value)}
                                />
                            </Control>
                        </Column>
                        <Column>
                            <label className="label">Customer Charge</label>
                            <Control className={"has-icons-left"}>
                                <Input
                                    type={"number"}
                                    name={""}
                                    onChange={(e) => setPartCustomerCost(e.target.value)}
                                />
                            </Control>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={() => {
                                    addPart();
                                    setOpen(false);
                                }}
                                isFullWidth
                            >
                                Add Part +
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => {
                                    setOpen(false);
                                }}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );




}